import React from 'react';

import './index.scss';

import clsx from 'clsx';

import CrossIcon from 'components/atoms/Icon/CrossIcon';
import ClickOnlyButton from 'components/atoms/Button/ClickOnlyButton';
import SpInputTitle from 'components/molecules/SpInputTitle';

const SpModal = ({
  modalIsOpen,
  errorDispMessages,
  content,
  button,
  onClickCloseButton,
  onClickBackButton,
  selectedDate,
  comment,
  radioChild,
  childInput,
  style,
  max,
  current,
  mdName,
}) => {
  const title = style === 2 ? '' : content.title;
  if (modalIsOpen) {
    return (
      <div className="SM-overlay" onClick={onClickCloseButton}>
        <div className="SM-content" onClick={(e) => e.stopPropagation()}>
          <div className="SM-header-area">
            <div className="SM-close-button-area">
              <button className="" type="button" onClick={onClickCloseButton}><CrossIcon /></button>
            </div>
            {style === 2 && current !== 1 ?
              <>
                <div className="SM-back-button-area">
                  <button className="SM-back-button" type="button" onClick={onClickBackButton}></button>
                </div>
              </> : <></>
            }
            <div className="SM-header">
              {style === 2 ?
                <>
                  <div className="title">
                    {mdName}
                  </div>
                </> :
                <>
                  <SpInputTitle title={title} subTitle={content.subTitle} label={content.label} questionMark={content.questionMark} popUpTitle={content.popUpTitle} popUpDetail={content.popUpDetail} type="TitleOnly" />
                </>
              }
            </div>
          </div>
          <div className={clsx({ "line": style === 2 })}></div>
          <div className='SM-wrapper'>
            <div className="SM-information-wrapper">
              {style === 2 ?
                <>
                  <div className="SM-step">
                    <span className="subTitle">{content.title}</span>
                    <StepNav max={max} current={current} />
                  </div>
                </> : <></>
              }
              <div className="SM-information">
                <SpInputTitle list={content.list} type={content.type} selectedDate={selectedDate} errorDispMessages={errorDispMessages} comment={comment} radioChild={radioChild} childInput={childInput} />
              </div>
              <div className="SM-next-button-area">
                <div className="SM-next-button">
                  <ClickOnlyButton label={button.label} onClick={button.onClick} valid={button.valid} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  return null;
};

const StepNav = ({ max, current }) => {
  return (
    <div className="select_nav">
      {Array.from({ length: max }, (_, index) => {
        return (
          <div
            id={`step${index}`}
            className={clsx("nav_inner",
              { after: index < current - 1 },
              { active: index === current - 1 },
            )}
            key={`step${index}`}
          >
            <span className={clsx({ nav_line: index + 1 < max })}></span>
            <span className="nav_icon"></span>
          </div>
        );
      })}
    </div>
  );
};

export default SpModal;